@use 'src/styles/config.module' as *;

.wrapper {
  border-radius: 0 0 4px 4px;
  background: $color-primary;
  color: #fff;
  margin: -2rem 0 0 2rem;
  width: 30rem;
  max-width: 13.6rem;
  transition: max-width .23s ease;
  .search {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-column-gap: 1rem;
    align-items: center;
    padding: 2.1rem 1.6rem .1rem 1rem;
    cursor: pointer;
    .input {
      width: 100%;
      background: none;
      border: none;
      color: #fff;
      border-right: 1px solid rgba(#fff, 0.3);
      height: 3.6rem;
      padding: 0 1rem 0 .6rem;
      transition: padding .23s ease, background .23s ease, color .23s ease;
      outline: none;
      cursor: pointer;
      font-size: 1.3rem;
      font-weight: 700;
      &::placeholder {
        color: #fff;
        font-size: 1.4rem;
        font-weight: 700;
        text-transform: uppercase;
        transition: font-size .23s ease, font-weight .23s ease, color .23s ease;
      }
    }
    .icon {
      font-size: 2.4rem;
    }
  }
  &.open {
    max-width: 30rem;
    .search {
      cursor: default;
      .input {
        padding: 0 1rem;
        background: #fff;
        color: $color-default;
        border-radius: 4px 4px 0 0;
        &::placeholder {
          font-size: 1.2rem;
          text-transform: capitalize;
          color: rgba($color-default, .5);
        }
      }
    }
  }
}

.popper {
  z-index: 9999;
  background: #fff;
  min-width: 20rem;
  padding: 1rem;
  box-shadow: 0 11px 15px -7px rgba(0, 0, 0, .2), 0px 24px 38px 3px rgba(0, 0, 0, .14);
  .results {
    display: flex;
    .result {
      padding: 0 1rem .5rem;
      width: 23vw;
      max-width: 30rem;
      max-height: 46vh;
      min-height: 30rem;
      display: grid;
      grid-template-rows: auto 1fr;
      border-left: 1px solid $color-border;
      &:first-child {
        border: none;
      }
      .title {
        font-size: 1.6rem;
        font-weight: 700;
        text-transform: uppercase;
        color: $color-primary;
        padding: .5rem;
        border-bottom: 1px solid $color-border;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .pagination {
          font-size: .9rem;
          font-weight: 400;
          color: $color-default;
          text-transform: none;
        }
      }
      .btn {
        font-size: 1.2rem;
        line-height: 1.2;
        padding: .8rem .5rem;
        border-bottom: 1px solid rgba($color-border, .5);
        width: 100%;
        justify-content: flex-start;
        text-align: left;
        &:last-child {
          border-bottom: none;
        }
        &:hover {
          background: $color-primary-light;
        }
      }
      :global {
        .native-scroll {
          .native-scroll__helper {
            position: static;
          }
        }
      }
    }
  }
}
